import * as types from "../../constants/ComponentConstants";

//todo memoize all
export function getFilesComponentProps(title, componentName, downloadUrl, documents, isDownloadOnly, onDrop, onDelete, fileTypes, center, validationMessageType, validationMessage, color, size) {

    const mappedOnDrop = (componentName) => {
        return (files) => onDrop(componentName, files);
    };

    const mappedOnDelete = (componentName) => {
        return (file) => onDelete(componentName, file);
    };

    return {
        title: title,
        componentName: componentName,
        color: color ? color : types.COLOR_BLUE,
        fileTypes: isDownloadOnly || !fileTypes ? null : fileTypes,
        downloadFileUrl: downloadUrl,
        files: getFiles(documents, componentName),
        onDrop: isDownloadOnly ? null : mappedOnDrop(componentName),
        onDelete: isDownloadOnly ? null : mappedOnDelete(componentName),
        isDownloadOnly: isDownloadOnly,
        center: center === undefined || !center ? false : center,
        validationMessageType: validationMessageType,
        validationMessage: validationMessage,
        size: size === undefined ? null : size,
        pollingEnabled: false
    };
}

export function getPollingProps(times, minFiles, isPolling, componentName) {
    return {
        pollingEnabled: true,
        minFiles: minFiles,
        pollTimes: times,
        isLoading: isPolling,
        componentName: componentName
    };
}

export function getFiles(documents, componentName, year) {
    let files = documents[componentName] ? documents[componentName] : [];
    if (year) {
        files = documents[componentName + year] ? documents[componentName + year] : [];
    }
    return files;
}

export function formatFilesForSave(documents, baseUrl) {
    let formattedFoldersWithDocuments = Object.keys(documents).map(k => {
        return ({
            files: documents[k].map(fn => {
                return {
                    name: fn,
                    path: baseUrl + "/" + k
                };
            }),
            name: k,
            path: baseUrl
        });
    });

    return formattedFoldersWithDocuments;
}